const sizeList = {
    unitSmall: 8,
    unitRegular: 16,
}

export default sizeList;